export default __webpack_public_path__ + "static/media/Close.30b0d5a5.svg";